import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { UnregisterCallback } from 'history';
import * as ReactGA from 'react-ga';

export class GoogleAnalytics extends React.Component<RouteComponentProps<{}>> {
    private unlisten: UnregisterCallback;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        ReactGA.initialize('UA-114649732-1');
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/tracking/GoogleAnalytics.tsx